import useIsMobile from 'Hook/useIsMobile';
import { useEffect } from 'react';

const PreventTabClose = ({ children }) => {
  const isMobile = useIsMobile();

  useEffect(() => {
    if (!isMobile) {
      // const broadCast = new BroadcastChannel('close-channel');

      window.addEventListener('beforeunload', (event) => {
        event.preventDefault();

        return 'Prevent Close';
      });

      window.addEventListener('unload', () => {
        // broadCast.postMessage('Closed Tab');
      });

      // broadCast.addEventListener('message', () => {});
    }
  }, [isMobile]);

  return children;
};

export default PreventTabClose;
